module.exports = __webpack_public_path__ + "static/img/5bg_5.eae955a.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/5bg_5.png
// module id = 730
// module chunks = 1